import { useState, useEffect, useRef } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import { styled } from "@mui/material/styles";
import { profileData } from "../common/Data"; // Assuming you have a data file for profile data

// Blinking cursor style
const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;
const BlinkingCursor = styled("span")`
  font-weight: normal;
  font-size: 56px;
  line-height: 1;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  animation: ${blink} 1s step-end infinite;
`;

const fullText = "Hi, I'm Vivek,\nAnd I am a competitive programmer!";

const Hero = () => {
  const [typedText, setTypedText] = useState("");
  const index = useRef(0);

  useEffect(() => {
    if (index.current < fullText.length) {
      const timeout = setTimeout(() => {
        // Only update if index is valid and character exists
        const nextChar = fullText[index.current];
        if (typeof nextChar === "string" && nextChar !== undefined) {
          setTypedText((prev) => prev + nextChar);
        }
        index.current += 1;
      }, 80);
      return () => clearTimeout(timeout);
    }
  }, [typedText]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row", // Arrange children horizontally
        minHeight: 320, // Minimum height for responsiveness
        minWidth: 320, // Minimum width for responsiveness
        width: "100%", // Take full width of parent
        overflow: "hidden", // Prevent scrolling on the main container
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          flex: "0 0 70%", // flex-grow: 0, flex-shrink: 0, flex-basis: 70% of width
          backgroundColor: "inherit", // Light teal background
          display: "flex",
          boxSizing: "border-box", // Include padding in the element's total width and height
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontSize: 40,
              fontWeight: 700,
              lineHeight: 1.5,
              whiteSpace: "pre-line",
            }}
          >
            {typedText}
            <BlinkingCursor>|</BlinkingCursor>
          </Typography>
          <br />
          <Typography sx={{ fontSize: 16, lineHeight: 1.5 }}>
            {profileData}
          </Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          flex: "0 0 30%", // flex-grow: 0, flex-shrink: 0, flex-basis: 30% of width
          backgroundColor: "inherit", // Light orange background
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "right",
          boxSizing: "border-box", // Include padding in the element's total width and height
        }}
      >
        <Box
          sx={{
            width: 260,
            height: 260,
            backgroundColor: "#eee",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
          }}
        >
          <img
            src="assets/images/ppm.png"
            alt="Vivek Rathi"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
